import React from 'react';
import * as R from 'ramda';
import { compose, setDisplayName, withHandlers, withState, lifecycle } from 'recompose';
import styled from '@emotion/styled';
import ThemeProvider from '@influitive/secret-garden/lib/theme-provider';
import defaults from '@influitive/secret-garden/lib/theme-provider/defaults';
import ModuleEvent from 'modules/module-event';
import { customBranding } from '../../api';
import ChallengesHeadingLink from '../challenges-heading-link';
import Challenges from '../challenges';
import { noChallengesEvent } from '../../common/events';

/* eslint-disable complexity */
const customBrandingTheme = customBranding => (customBranding && customBranding.color_scheme) ? {
  colors: {
    primary: [ R.path(['color_scheme', 'primary_color'], customBranding) ],
    secondary: [ R.path(['color_scheme', 'secondary_color'], customBranding) ]
  },
  fonts: {
    family: customBranding.custom_font_enabled
      ? R.insert(0, customBranding.custom_font_name, defaults.fonts.family)
      : defaults.fonts.family,
    custom: customBranding.custom_font_enabled ? {
      fontName: customBranding.custom_font_name,
      fontUrl: customBranding.custom_font_url
    } : null
  }
} : {};
/* eslint-enable complexity */

const App = styled('div')`
  display: ${props => props.isVisible ? 'block' : 'none'};
  ${props => props.theme.fonts.custom && `
    @font-face {
      font-family: ${props.theme.fonts.family.join(', ')};
      font-style: normal;
      src: url(${props.theme.fonts.custom.fontUrl});
    }
  `}
  font-family: ${props => props.theme.fonts.family.join(', ')} !important;
`;

const checkChallengePlayer = () => (
  window &&
  window.inflComp &&
  window.inflComp.ChallengeModalView &&
  typeof window.inflComp.ChallengeModalView === 'function'
);

export default compose(
  withState('customBranding', 'brandingReceived', null),
  withState('challengePlayer', 'setChallengePlayer', null),
  withState('isVisible', 'setVisibility', true),
  withHandlers({
    handleChallengeOpen: ({ challengePlayer }) => challenge => {
      challengePlayer
        ? challengePlayer.open(challenge)
        : (window.location = `/challenges/${challenge.id}`);
    },
    handleNoChallenges: ({ setVisibility }) => () => {
      setVisibility(false);
      window.dispatchEvent(noChallengesEvent);
    }
  }),
  lifecycle({
    componentDidMount() {
      customBranding().then(this.props.brandingReceived);
      checkChallengePlayer && this.props.setChallengePlayer(window.inflComp.ChallengeModalView());
      ModuleEvent('CHALLENGES_CAROUSEL', 'LOADED');
    }
  }),
  setDisplayName('ChallengesCarousel')
)(({ customBranding, handleChallengeOpen, handleNoChallenges, isVisible }) => (
  <ThemeProvider theme={customBrandingTheme(customBranding)}>
    <App isVisible={isVisible} data-qa="CHALLENGES-CAROUSEL_app">
      <ChallengesHeadingLink />
      <Challenges
        onNoChallenges={handleNoChallenges}
        onChallengeOpen={handleChallengeOpen} />
    </App>
  </ThemeProvider>
));
